import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CHANNEL_STATUS, IChannel } from '@/entities/channel';
import { Dialog, TDialogProps } from '@/shared/ui/Dialog';
import { Button } from '@/shared/ui/lib/Button';
import { Loader } from '@/shared/ui/Loader';

import { useQrCodeByChannel } from '../../model/scanQrCode/useQrCodeByChannel';
import { useLoginChannelByQr } from '../../model/useLoginChannelByQr';

import { DialogContent } from './DialogContent';

export type TWhatsappPersonalQrCodeDialogProps = TDialogProps & {
  channel: IChannel;
  onAuthorize?: () => void;
  isPending?: boolean;
};

export const WhatsappPersonalQrCodeDialog = ({
  open,
  onClose,
  channel,
  title,
  isPending,
  onAuthorize,
  ...otherProps
}: TWhatsappPersonalQrCodeDialogProps) => {
  const { t } = useTranslation();

  const { channelLogin } = useLoginChannelByQr();
  const shouldOnceRequest = useRef(true);

  // Выполняем запрос только один раз при открытии диалога
  useEffect(() => {
    if (
      shouldOnceRequest.current &&
      open &&
      channel.status === CHANNEL_STATUS.UNAUTHORIZED
    ) {
      shouldOnceRequest.current = false;
      channelLogin(channel.id);
    }
  }, [open, channel.status, channel.id, channelLogin]);

  const { dataChannelById } = useQrCodeByChannel(channel.id, open, open, () => {
    onAuthorize?.();
  });

  return (
    <Dialog
      open={open}
      title={title ?? channel.id}
      onClose={onClose}
      leftButtonSlot={
        <Button variant="outlined" onClick={onClose}>
          {t('channels:buttons.closeModal')}
        </Button>
      }
      {...otherProps}
    >
      {isPending ? (
        <Loader containerSize="small" />
      ) : (
        <DialogContent qr={dataChannelById?.qr_url} id={channel.id} />
      )}
    </Dialog>
  );
};
